import StrainComparison from "./StrainComparison";

export default StrainComparison;
